import {
  question,
  question_category_select,
  question_type_select,
  lesson_select,
  test_select,
  level_select,
  topic_select,
  subject_select,
} from "@Modules/Question/configs/constants";

import list_question from "./reducers";
import list_question_category_select from "./reducers/cateSelect";
import list_question_type_select from "./reducers/typeSelect";
import list_lesson_select from "./reducers/lessonSelect";
import list_test_select from "./reducers/testSelect";
import list_level_select from "./reducers/levelSelect";
import list_topic_select from "./reducers/topicSelect";
import list_subject_select from "./reducers/subjectSelect";

export default {
  [question]: list_question,
  [question_category_select]: list_question_category_select,
  [question_type_select]: list_question_type_select,
  [lesson_select]: list_lesson_select,
  [test_select]: list_test_select,
  [level_select]: list_level_select,
  [topic_select]: list_topic_select,
  [subject_select]: list_subject_select,
};
